import { AppSettingsContext } from "contexts/AppSettingsContext";
import { useContext } from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";

/**
 * Modal showing developer and environment information used for debugging.
 *
 * @param props - Destructured props for the modal.
 * @param props.show - Whether the modal is visible.
 * @param props.setShow - Callback to update the visible state of the modal.
 * @returns A JSX element rendering the information modal.
 */
export const BottomNavInfoModal = ({
  show,
  setShow,
}: {
  show: boolean;
  setShow: (ret: boolean) => void;
}): React.ReactElement => {
  const appSettings = useContext(AppSettingsContext);

  return (
    <Modal
      id="bottomnav-info-modal"
      show={show}
      onHide={() => setShow(false)}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <Container>Developer information panel</Container>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col>
              Application version: {process.env.npm_package_name} {process.env.npm_package_version}
            </Col>
          </Row>
          <Row>
            <Col>Stage: {process.env.REACT_APP_STAGE}</Col>
          </Row>
          <Row>
            <Col>Backend URL: {appSettings.backEndUrl}</Col>
          </Row>
          <Row>
            <Col>Backend versions: {appSettings.backEndVersion}</Col>
          </Row>
          <Row className="mt-2">
            <Col>
              Application permissions:
              {appSettings.isAdmin ? (
                <div>
                  <span className="mx-3">Admin</span>
                </div>
              ) : (
                <></>
              )}
              {appSettings.applicationPermissions.length === 0 ? (
                <div>
                  <span className="mx-3">No permissions assigned</span>
                </div>
              ) : (
                appSettings.applicationPermissions.map((p) => (
                  <div key={p}>
                    <span className="mx-3">{p}</span>
                  </div>
                ))
              )}
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <span id="hierarchy-context-info" />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <span id="toc-context-info" />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <span id="tlf-context-info" />
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};

BottomNavInfoModal.displayName = "BottomNavInfoModal";
